import { createAction } from '@reduxjs/toolkit';

export const ELEMENTS_ACTION_CHANGE_ELEMENT = 'changeElement';
export const dragElement = createAction('dragElement');
export const selectSingleElement = createAction('selectSingleElement');
export const rotateElement = createAction('rotateElement');
export const changeElement = createAction(ELEMENTS_ACTION_CHANGE_ELEMENT);
